import { render, staticRenderFns } from "./disponibilidade_telemedicina.vue?vue&type=template&id=165769e8"
import script from "./disponibilidade_telemedicina.vue?vue&type=script&lang=js"
export * from "./disponibilidade_telemedicina.vue?vue&type=script&lang=js"
import style0 from "./disponibilidade_telemedicina.vue?vue&type=style&index=0&id=165769e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports